import { render, staticRenderFns } from "./drugs.vue?vue&type=template&id=14b42f10&"
import script from "./drugs.vue?vue&type=script&lang=js&"
export * from "./drugs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports